import { useEffect, useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'

// Ustava (Mirko 25.7.): clovek = MENO A PRIEZVISKO, nie username ('mirko').
// Jeden zdroj pravdy pre cely Matrix: /api/users -> { username_lower: display_name }.
let _cache = null
let _inflight = null
const _subs = new Set()

function _load() {
  if (_cache) return Promise.resolve(_cache)
  if (_inflight) return _inflight
  _inflight = fetchAuth('/api/users')
    .then(r => (r && r.ok) ? r.json() : [])
    .then(list => {
      const m = {}
      ;(Array.isArray(list) ? list : []).forEach(u => {
        if (!u || !u.username) return
        const dn = String(u.cele_meno || '').trim() || String(u.display_name || '').trim() || String(u.username)   // funkcia_v1: celé meno z karty
        m[String(u.username).toLowerCase()] = dn
      })
      _cache = m
      _subs.forEach(fn => { try { fn(m) } catch (_) {} })
      return m
    })
    .catch(() => { _cache = {}; return _cache })
  return _inflight
}

// Ciste zobrazenie: prazdny vstup -> '', znamy username -> meno, neznamy -> username (fallback).
export function menoOsoby(u, map) {
  if (u == null || u === '') return ''
  const m = map || _cache || {}
  return m[String(u).toLowerCase()] || String(u)
}

export function usePersony() {
  const [map, setMap] = useState(_cache || {})
  useEffect(() => {
    let alive = true
    const fn = (m) => { if (alive) setMap(m) }
    _subs.add(fn)
    _load().then(m => { if (alive) setMap(m) })
    return () => { alive = false; _subs.delete(fn) }
  }, [])
  return { map, meno: (u) => menoOsoby(u, map) }
}
